<template>
  <div>
    <section class="fullscreen flex-container">
      <Header />
    </section>
    <Content title="Accommodation" icon="home-heart">
      <CopyWithImage
        flexDirection="column"
        :src="require('@/assets/images/glentana-house.jpg')"
      >
        <p>
          There will be several houses available from the 25th to the 2nd.
          People traveling from overseas will be prioritised. We will be
          assigning people to rooms so they will be staying with people they
          know, if possible.
        </p>
        <p>
          The accommodation, ceremony, and reception are all located in Glentana
          so there will be no problems with travel once you have arrived.
        </p>
      </CopyWithImage>

      <FlexContainer>
        <FlexItem size="50%" padding="normal">
          <iframe
            width="100%"
            height="300"
            frameborder="0"
            style="border:0"
            src="https://www.google.com/maps/embed/v1/search?key=AIzaSyCyizT_crC0TUECIew8_TODnwijtk3Lo2g&q=77+Gleniqua+Drive,+Glentana,+Groot+Brakrivier,+South+Africa"
            allowfullscreen
          ></iframe>
        </FlexItem>
        <FlexItem size="50%" padding="normal">
          <p>
            77 Gleniqua Drive<br />
            Glentana<br />
            Groot Braakrivier<br />
            South Africa
          </p>
        </FlexItem>
      </FlexContainer>
    </Content>
  </div>
</template>

<script>
import Header from '@/components/ui/Header.vue';
import Content from '@/components/ui/Content.vue';
import FlexContainer from '@/components/ui/FlexContainer.vue';
import FlexItem from '@/components/ui/FlexItem.vue';
import CopyWithImage from '@/components/ui/CopyWithImage.vue';
import ButtonLink from '@/components/ui/ButtonLink.vue';

export default {
  name: 'Accommodation',
  components: {
    Header,
    Content,
    FlexContainer,
    FlexItem,
    CopyWithImage,
    ButtonLink
  }
};
</script>

<style lang="scss" scoped>
> section:first-of-type {
  min-height: 10vh;

  @include respond-below(sm) {
    padding: $padding;
  }
}

.section__two {
  background: white;
}
</style>
